export default {
	selectAll: 'Tout sélectionner'
};
